import { UIMessage } from "ai";

const SUGGESTIONS_REGEX = /<suggestions>[\s\S]*?(<\/suggestions>|$)/g;

/** Strips `<suggestions>...</suggestions>` blocks and `[RESET]` prefixes from message text. */
export function stripSuggestions(text: string): string {
  return text
    .replace(SUGGESTIONS_REGEX, "")
    .replaceAll(RESET_SUGGESTION_PREFIX, "")
    .trim();
}

/** Parses suggestion strings from the last `<suggestions>` block in text. */
export function parseSuggestions(text: string): string[] {
  const match = text.match(/<suggestions>\s*(\[[\s\S]*?\])\s*<\/suggestions>/);
  if (!match) return [];
  try {
    const parsed: unknown = JSON.parse(match[1]);
    if (Array.isArray(parsed) && parsed.every((s) => typeof s === "string")) {
      return parsed;
    }
    return [];
  } catch {
    return [];
  }
}

/** Prefix used by the AI to mark a suggestion that should trigger a reset confirmation. */
export const RESET_SUGGESTION_PREFIX = "[RESET]";

/** Returns true if a suggestion string starts with the reset prefix. */
export function isResetSuggestion(suggestion: string): boolean {
  return suggestion.startsWith(RESET_SUGGESTION_PREFIX);
}

/** Strips the reset prefix from a suggestion for display purposes. */
export function stripResetPrefix(suggestion: string): string {
  return suggestion.replace(RESET_SUGGESTION_PREFIX, "").trim();
}

/** Checks if a message is a system trigger ("start" or "resume"). */
export function isSystemTrigger(message: UIMessage): boolean {
  const text = message.parts
    .filter((p) => p.type === "text")
    .map((p) => p.text)
    .join("")
    .trim()
    .toLowerCase();
  return text === "start" || text === "resume";
}
